// eslint-disable-next-line import/no-unresolved
import { createSelector } from 'reselect';
import { accountsSelector } from '@t7x000/apex-web/lib/redux/margin/selectors';
import { RETIREMENT_ACCOUNT_SUFFIX } from '../../constants';

const selectedAccountIdSelector = (state) => state.user.selectedAccountId;

export const selectedAccountSelector = createSelector(
  [accountsSelector, selectedAccountIdSelector],
  (accounts, selectedAccountId) => accounts.find((account) => Number(account.AccountId) === Number(selectedAccountId)),
);

export const isSelectedAccountRetirementSelector = createSelector([selectedAccountSelector], (selectedAccount) =>
  Boolean(selectedAccount?.AccountName?.endsWith(RETIREMENT_ACCOUNT_SUFFIX)),
);
